// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'informed';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';
import { PrimaryText, Warning } from '../../Typography.jsx';

import CovidTests from './CovidTests.jsx';
import UrinalysisTests from './UrinalysisTests.jsx';
import HIVTests from './HIVTests.jsx';
import HIVInfo from './HIVInfo.jsx';
import TBTests from './TBTests.jsx';
import TBScreenings from './TBScreenings.jsx';
import HemoglobinTests from './HemoglobinTests.jsx';
import GlucoseTests from './GlucoseTests.jsx';
import SyphilisTests from './SyphilisTests.jsx';
import MiscTests from './MiscTests.jsx';

type Props = {
  print: boolean,
}

class TestingPageComponent extends Component<Props> {
  render() {
    return (
      <div>
        <PageHeader title="Testing" />
        <ContentBox title="HIV" id='hiv'>
          <HIVTests />
          <Form component={HIVInfo} autoComplete='off' />
        </ContentBox>
        <ContentBox title="Tuberculosis" id='tb'>
          <PrimaryText>Tuberculosis Tests</PrimaryText>
          <br />
          <TBTests />
          <br />
          <PrimaryText>Tuberculosis Screenings</PrimaryText>
          <br />
          <TBScreenings />
        </ContentBox>
        <ContentBox title="Hemoglobin" id='hemoglobin'>
          {!this.props.print
            && <div>
              <Warning>If taking or discontinuing iron, update problem and medication list accordingly.</Warning>
              <br /><br />
            </div>
          }
          <HemoglobinTests />
        </ContentBox>
        <ContentBox title="Glucose" id='glucouse'>
          <GlucoseTests />
        </ContentBox>
        <ContentBox title="Syphilis" id='syphilis'>
          <SyphilisTests />
        </ContentBox>
        <ContentBox title="Urinalysis" id='urinalysis'>
          <UrinalysisTests />
        </ContentBox>
        <ContentBox title="COVID-19" id='covid'>
          <CovidTests />
        </ContentBox>
        <ContentBox title="Miscellaneous" id='misc'>
          <MiscTests />
        </ContentBox>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  print: state.patient.print,
});

const TestingPage = connect(
  mapStateToProps,
)(TestingPageComponent);

export default TestingPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/testing/TestingPage.jsx